import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CaModalOverlayRef } from '@global-front-components/ui/modal-overlay';

@Component({
	selector: 'app-modal-informacion-imagen',
	standalone: true,
	imports: [CommonModule],
	templateUrl: './modal-informacion-imagen.component.html',
	styleUrls: ['./modal-informacion-imagen.component.scss']
})
export class ModalInformacionImagenComponent {
	@Input() data!: any;
	urlImagen: string;
	
	constructor(
		private _modalRef: CaModalOverlayRef<ModalInformacionImagenComponent>,		
	) { }

	closeDialog(text?: string): void {
		if (text) {
			this._modalRef.close(text);
		} else {
			this._modalRef.close();
		}
	}
}
